import React, { useState, useEffect } from 'react';
import Lottie from 'react-lottie';
import loaderData from '../assets/loader.json'; // Adjust the path as needed
import image1 from "../assets/logowhite.png";
const bgImage1 = "https://i.ibb.co/tMFhqYh6/IMG-6448.jpg"; // This is the external image URL

const Loader = () => {
  const [showAnimation, setShowAnimation] = useState(true);

  // List of background images (no need to store in localStorage)
  const bgImages = [
    bgImage1, // You can add more image URLs here if needed
  ];

  const defaultOptions = {
    loop: true,
    autoplay: true,
    animationData: loaderData,
    rendererSettings: {
      preserveAspectRatio: 'xMidYMid slice',
    },
  };

  // Toggle animation every 5 seconds
  useEffect(() => {
    const timer = setInterval(() => {
      setShowAnimation((prev) => !prev);
    }, 5000);

    return () => clearInterval(timer); // Clean up the timer on component unmount
  }, []);

  // Random background image selector
  const randomBgImage = bgImages[Math.floor(Math.random() * bgImages.length)];

  return (
    <div
      className="flex items-center justify-center h-screen relative bg-cover bg-center"
      style={{
        backgroundImage: `url(${randomBgImage})`, // Randomly select the background image
        backgroundSize: 'cover',
        backgroundPosition: 'center',
      }}
    >
      {/* Gradient Overlay */}
      <div className="absolute inset-0 bg-gradient-to-r from-red-800 to-gray-900 opacity-90"></div>
      
      {/* Content */}
      {showAnimation ? (
        <img src={image1} alt="" className="w-40 h-40 relative z-10" />
      ) : (
        <Lottie options={defaultOptions} height={200} width={200} />
      )}
    </div>
  );
};

export default Loader;
